<template>
  <div class="form-item-flex-row">
    <el-input v-model="start" placeholder="起始时间"></el-input>
    <span style="padding:0 5px;"><i class="el-icon-minus"></i></span>
    <el-input v-model="end" placeholder="结束时间"></el-input>
  </div>
</template>

<script>
import utils from './../js/utils'

export default {
  name: 'TimeRangeInput',
  props: {
    value: {
      type: [Array, String]
    },
    duration: {
      type: Boolean,
      default: false
    },
    asarray: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      start: '',
      end: '',
      nativeValue: null
    }
  },
  watch: {
    value () {
      this.handleValue()
    },
    duration () {
      this.handleValue()
    },
    start (newVal, oldVal) {
      newVal === oldVal || this.handleChange()
    },
    end (newVal, oldVal) {
      newVal === oldVal || this.handleChange()
    }
  },
  mounted () {
    this.value && this.handleValue()
  },
  methods: {
    handleChange () {
      let val
      if (this.duration) {
        val = this.end ? [this.start, this.end] : [this.start]
      } else {
        let start = utils.asMillisecond(this.start)
        let end = utils.asMillisecond(this.end)
        val = end ? [start, end] : [start]
      }
      this.nativeValue = this.asarray ? val : val.join('-')
      this.$emit('input', this.nativeValue)
    },
    handleValue () {
      if (this.nativeValue === this.value) return
      this.nativeValue = this.value
      let val = this.value
      if (typeof val === 'string') {
        val = val.split('-')
      }
      if (val.length > 0) {
        this.start = this.isMillisecond(val[0]) ? utils.asDuration(val[0]) : val[0]
      } else {
        this.start = ''
      }
      if (val.length > 1) {
        this.end = this.isMillisecond(val[1]) ? utils.asDuration(val[1]) : val[1]
      } else {
        this.end = ''
      }
    },
    isMillisecond (time) {
      return typeof time === 'number' || /^\d+$/.test(time)
    }
  }
}
</script>
